import { render } from "./AppUploadControls.vue?vue&type=template&id=6c97d734&scoped=true&ts=true"
import script from "./AppUploadControls.vue?vue&type=script&lang=ts"
export * from "./AppUploadControls.vue?vue&type=script&lang=ts"

import "./AppUploadControls.vue?vue&type=style&index=0&id=6c97d734&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c97d734"]])

export default __exports__